var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 200,
    viewBox: "0 0 854 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h854v200H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.177 97l.335-3.953c1.519-.134 2.613-.268 3.283-.402.715-.179 1.206-.402 1.474-.67.268-.313.402-.76.402-1.34 0-.536-.112-1.318-.335-2.345l-1.407-5.159a162.54 162.54 0 00-6.164-.134c-.804 0-2.479.112-5.025.335l-1.407.134-1.675 5.159c-.268.983-.402 1.675-.402 2.077 0 .804.223 1.362.67 1.675.491.313 1.318.469 2.479.469h2.881l.335.469-.469 4.087c-.625-.045-1.965-.134-4.02-.268-2.055-.09-3.975-.134-5.762-.134-1.876 0-3.573.022-5.092.067-1.474.045-2.457.09-2.948.134l.469-4.355c1.027-.179 1.876-.603 2.546-1.273.67-.67 1.295-1.764 1.876-3.283l11.993-33.969 10.251-1.072.737.335c.67 2.546 2.055 7.772 4.154 15.678 2.144 7.861 3.975 14.182 5.494 18.961.491 1.608 1.117 2.747 1.876 3.417.759.67 1.898 1.072 3.417 1.206l.268.469-.469 3.886c-.581-.045-1.675-.09-3.283-.134a176.012 176.012 0 00-4.891-.067c-2.367 0-4.69.067-6.968.201-2.233.179-3.663.29-4.288.335l-.335-.536zm-2.412-19.162c.491 0 2.144-.067 4.958-.201l-3.953-14.941h-.871l-4.958 15.142h4.824zm42.174 15.544c1.117-.223 1.899-.625 2.345-1.206.492-.58.76-1.43.804-2.546l.201-11.591c0-1.965-.357-3.417-1.072-4.355-.714-.983-1.809-1.474-3.283-1.474-1.697 0-3.662.849-5.896 2.546-.446 8.04-.67 13.065-.67 15.075 0 1.117.134 1.898.402 2.345.313.447.849.67 1.608.67l1.809-.067.134.268-.67 4.154c-.491-.045-1.429-.09-2.814-.134-1.34-.045-2.747-.067-4.221-.067-1.429 0-2.992.045-4.69.134-1.652.134-2.724.223-3.216.268l.536-4.154c1.296-.134 2.189-.469 2.68-1.005.536-.58.804-1.496.804-2.747V75.292c0-1.563-.245-2.613-.737-3.149-.446-.58-1.295-.871-2.546-.871h-.871l-.268-.335.335-3.484c2.546-.357 5.048-.782 7.504-1.273 2.502-.491 4.11-.804 4.824-.938l.536.67c-.089.268-.223.871-.402 1.809-.178.938-.29 1.876-.335 2.814l.268.268c1.385-1.206 2.971-2.412 4.757-3.618 1.832-1.25 3.149-1.876 3.953-1.876 3.172 0 5.628.76 7.37 2.278 1.787 1.519 2.68 3.64 2.68 6.365 0 .67-.178 3.015-.536 7.035-.446 4.556-.67 7.482-.67 8.777 0 1.161.157 1.988.469 2.479.358.491.894.737 1.608.737.447 0 .871-.022 1.273-.067.402-.045.67-.067.804-.067l.134.268-.603 4.087c-.536-.045-1.518-.09-2.948-.134a132.957 132.957 0 00-4.288-.067c-1.072 0-2.456.067-4.154.201-1.652.179-2.747.29-3.283.335l.335-4.154zm37.622 0c1.117-.223 1.899-.625 2.345-1.206.492-.58.76-1.43.804-2.546l.201-11.591c0-1.965-.357-3.417-1.072-4.355-.714-.983-1.809-1.474-3.283-1.474-1.697 0-3.662.849-5.896 2.546-.446 8.04-.67 13.065-.67 15.075 0 1.117.134 1.898.402 2.345.313.447.849.67 1.608.67l1.809-.067.134.268-.67 4.154c-.491-.045-1.429-.09-2.814-.134-1.34-.045-2.747-.067-4.221-.067-1.429 0-2.992.045-4.69.134-1.652.134-2.724.223-3.216.268l.536-4.154c1.296-.134 2.189-.469 2.68-1.005.536-.58.804-1.496.804-2.747V75.292c0-1.563-.245-2.613-.737-3.149-.446-.58-1.295-.871-2.546-.871h-.871l-.268-.335.335-3.484c2.546-.357 5.048-.782 7.504-1.273 2.502-.491 4.11-.804 4.824-.938l.536.67c-.089.268-.223.871-.402 1.809-.178.938-.29 1.876-.335 2.814l.268.268c1.385-1.206 2.971-2.412 4.757-3.618 1.832-1.25 3.149-1.876 3.953-1.876 3.172 0 5.628.76 7.37 2.278 1.787 1.519 2.68 3.64 2.68 6.365 0 .67-.178 3.015-.536 7.035-.446 4.556-.67 7.482-.67 8.777 0 1.161.157 1.988.469 2.479.358.491.894.737 1.608.737.447 0 .871-.022 1.273-.067.402-.045.67-.067.804-.067l.134.268-.603 4.087c-.536-.045-1.518-.09-2.948-.134a132.957 132.957 0 00-4.288-.067c-1.072 0-2.456.067-4.154.201-1.652.179-2.747.29-3.283.335l.335-4.154zm41.844 4.422c-1.966 0-3.529-.424-4.69-1.273-1.117-.893-1.787-2.189-2.01-3.886l-.536-.201c-1.43 1.474-2.814 2.702-4.154 3.685-1.34.938-2.412 1.407-3.216 1.407-2.636 0-4.824-.916-6.566-2.747-1.742-1.876-2.613-4.199-2.613-6.968 0-1.385.357-2.568 1.072-3.551.714-1.027 1.652-1.697 2.814-2.01l12.931-3.015.067-1.608c0-1.92-.514-3.417-1.541-4.489-1.028-1.072-2.435-1.608-4.221-1.608-1.206 0-2.524.313-3.953.938a18.565 18.565 0 00-3.886 2.211l-.603-.268-1.139-4.02a79.188 79.188 0 017.035-3.484c2.456-1.072 4.198-1.608 5.226-1.608 3.707 0 6.476.849 8.308 2.546 1.876 1.653 2.814 3.841 2.814 6.566 0 .983-.201 2.993-.603 6.03-.492 4.333-.737 6.923-.737 7.772 0 .849.223 1.519.67 2.01.446.491 1.027.737 1.742.737.536 0 1.094-.112 1.675-.335.625-.268 1.139-.536 1.541-.804l1.005 1.407c-.804 1.43-1.809 2.814-3.015 4.154-1.162 1.295-2.301 2.1-3.417 2.412zm-12.127-6.633c.67 0 1.451-.179 2.345-.536a8.951 8.951 0 002.479-1.407l.201-6.365-7.169 2.01c-1.072.268-1.608 1.005-1.608 2.211 0 1.161.335 2.144 1.005 2.948.714.76 1.63 1.139 2.747 1.139zm45.307 6.633c-2.055 0-3.953-.201-5.695-.603-1.742-.357-3.194-.76-4.355-1.206-1.117-.447-1.675-.692-1.675-.737l-.536-.938c.044-.313.134-.983.268-2.01.178-1.072.357-2.479.536-4.221a52.09 52.09 0 00.268-5.159l5.494-.402c0 2.501.223 4.422.67 5.762.446 1.34 1.183 2.3 2.211 2.881 1.072.536 2.59.804 4.556.804 2.144 0 3.863-.469 5.159-1.407 1.295-.938 1.943-2.233 1.943-3.886 0-1.474-.693-2.725-2.077-3.752-1.34-1.027-3.44-2.233-6.298-3.618-.179-.09-.693-.335-1.541-.737-3.35-1.608-5.963-3.305-7.839-5.092-1.876-1.787-2.814-4.11-2.814-6.968 0-2.546.759-4.824 2.278-6.834 1.518-2.055 3.618-3.64 6.298-4.757 2.724-1.161 5.806-1.742 9.246-1.742 1.965 0 3.774.134 5.427.402 1.697.268 3.037.558 4.02.871 1.027.268 1.675.447 1.943.536l.469.871c-.045.268-.179.96-.402 2.077-.224 1.072-.447 2.457-.67 4.154a93.258 93.258 0 00-.536 5.226l-4.958.402-.603-.402c0-.134.022-.402.067-.804.044-.447.067-.983.067-1.608 0-2.01-.514-3.44-1.541-4.288-.983-.849-2.658-1.273-5.025-1.273-1.921 0-3.507.469-4.757 1.407-1.206.893-1.809 2.055-1.809 3.484 0 1.072.379 2.055 1.139 2.948a12.571 12.571 0 002.814 2.211c1.116.625 2.724 1.452 4.824 2.479 2.501 1.206 4.556 2.3 6.164 3.283a13.95 13.95 0 014.154 3.752c1.116 1.519 1.675 3.328 1.675 5.427 0 2.68-.782 5.047-2.345 7.102-1.519 2.01-3.685 3.573-6.499 4.69-2.77 1.117-6.008 1.675-9.715 1.675zm35.179 0c-3.171 0-5.494-.648-6.968-1.943-1.474-1.34-2.211-3.44-2.211-6.298V74.622c0-1.43-.246-2.367-.737-2.814-.491-.491-1.452-.76-2.881-.804l-.67-.469.469-3.283a50.406 50.406 0 005.025-2.747c1.653-1.072 3.015-2.01 4.087-2.814 1.117-.804 1.809-1.318 2.077-1.541l1.876.938c-.045.268-.156.916-.335 1.943a94.692 94.692 0 00-.402 3.819l7.906-.201.268.335-.67 4.489-7.906-.201c-.268 3.886-.402 8.755-.402 14.606 0 1.92.335 3.305 1.005 4.154.67.849 1.764 1.273 3.283 1.273.804 0 1.608-.134 2.412-.402.849-.268 1.385-.447 1.608-.536l.871 2.144c-.268.268-.916.826-1.943 1.675a38.158 38.158 0 01-3.216 2.479c-1.117.76-1.965 1.139-2.546 1.139zm24.725 0c-2.814 0-5.293-.625-7.437-1.876-2.144-1.295-3.797-3.104-4.958-5.427-1.161-2.323-1.742-5.003-1.742-8.04 0-3.35.67-6.32 2.01-8.911 1.385-2.59 3.283-4.6 5.695-6.03 2.457-1.474 5.271-2.211 8.442-2.211 4.333 0 7.75 1.385 10.251 4.154 2.546 2.725 3.819 6.432 3.819 11.122 0 3.35-.67 6.343-2.01 8.978-1.34 2.59-3.238 4.623-5.695 6.097-2.412 1.43-5.204 2.144-8.375 2.144zm1.34-5.025c1.921 0 3.372-.76 4.355-2.278 1.027-1.563 1.541-3.841 1.541-6.834 0-4.199-.581-7.37-1.742-9.514-1.161-2.144-2.836-3.216-5.025-3.216-1.921 0-3.395.782-4.422 2.345-.983 1.519-1.474 3.774-1.474 6.767 0 4.199.581 7.37 1.742 9.514 1.161 2.144 2.836 3.216 5.025 3.216zm-3.886-30.954l-2.077-2.479c2.233-2.278 4.444-4.6 6.633-6.968 2.233-2.412 3.663-3.975 4.288-4.69h.871l3.752 4.489-.067.871c-.715.491-2.323 1.63-4.824 3.417a157.59 157.59 0 00-7.571 5.628l-1.005-.268zm31.351 35.979c-1.608 0-3.082-.134-4.422-.402-1.295-.268-2.322-.536-3.082-.804a30.64 30.64 0 01-1.407-.603l-.402-.67c.179-1.206.335-2.613.469-4.221.179-1.608.313-3.149.402-4.623l3.685-.335c.045 4.511 2.033 6.767 5.963 6.767 1.296 0 2.368-.268 3.216-.804.849-.58 1.273-1.295 1.273-2.144 0-.893-.446-1.697-1.34-2.412-.893-.76-2.68-1.787-5.36-3.082-2.68-1.25-4.623-2.568-5.829-3.953-1.206-1.43-1.809-3.082-1.809-4.958 0-2.01.581-3.774 1.742-5.293 1.162-1.563 2.792-2.77 4.891-3.618 2.1-.893 4.489-1.34 7.169-1.34 1.296 0 2.502.09 3.618.268 1.117.179 1.988.38 2.613.603.67.179 1.095.29 1.273.335l.335.67-.603 3.35a90.252 90.252 0 00-.67 5.293l-3.752.268.067-1.206c0-1.563-.379-2.702-1.139-3.417-.759-.76-1.943-1.139-3.551-1.139-1.161 0-2.144.29-2.948.871-.804.536-1.206 1.228-1.206 2.077s.358 1.63 1.072 2.345c.715.715 1.899 1.474 3.551 2.278 2.636 1.25 4.646 2.367 6.03 3.35 1.43.983 2.412 1.988 2.948 3.015.581.983.871 2.166.871 3.551 0 1.831-.603 3.506-1.809 5.025-1.206 1.519-2.858 2.725-4.958 3.618-2.099.893-4.399 1.34-6.901 1.34z",
    fill: "#292B37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.92 158.72c-3.52 0-6.6-.76-9.24-2.28-2.64-1.52-4.68-3.66-6.12-6.42-1.44-2.8-2.16-6.08-2.16-9.84 0-4.12.88-7.78 2.64-10.98 1.76-3.2 4.24-5.68 7.44-7.44 3.2-1.8 6.86-2.7 10.98-2.7 1.48 0 3.08.12 4.8.36 1.72.2 3.2.42 4.44.66 1.24.2 2.04.34 2.4.42l.24.36c-.08.24-.22.82-.42 1.74-.2.92-.42 2.12-.66 3.6-.2 1.48-.36 3.04-.48 4.68l-2.82.24c.04-.2.08-.58.12-1.14.04-.6.06-1.3.06-2.1 0-1.84-.72-3.18-2.16-4.02-1.4-.84-3.7-1.26-6.9-1.26-4.56 0-8.12 1.38-10.68 4.14-2.52 2.72-3.78 6.56-3.78 11.52 0 3.48.56 6.54 1.68 9.18 1.12 2.64 2.72 4.68 4.8 6.12 2.08 1.44 4.48 2.16 7.2 2.16 1.44 0 2.76-.16 3.96-.48 1.2-.36 2.2-.74 3-1.14.84-.4 1.26-.62 1.26-.66v-7.32c0-1.36-.22-2.24-.66-2.64-.4-.4-1.28-.6-2.64-.6h-4.14l-.12-.24.54-3c.48.04 1.5.1 3.06.18 1.56.04 3.08.06 4.56.06 1.08 0 2.14-.04 3.18-.12 1.04-.08 1.7-.14 1.98-.18l.24 1.32c-.72.6-1.22 1.56-1.5 2.88-.24 1.28-.36 3.4-.36 6.36 0 2.32.14 4.08.42 5.28l-.36.54c0 .04-.72.32-2.16.84-1.4.48-3.14.92-5.22 1.32-2.04.4-4.18.6-6.42.6zm41.834 0c-3.24 0-5.02-1.62-5.34-4.86l-.24-.06c-1.44 1.44-2.76 2.58-3.96 3.42-1.16.84-2.04 1.26-2.64 1.26-2.24 0-4.08-.7-5.52-2.1-1.44-1.4-2.16-3.18-2.16-5.34 0-1.16.28-2.18.84-3.06.6-.88 1.38-1.46 2.34-1.74l11.4-3.12.06-2.64c0-2-.46-3.56-1.38-4.68-.92-1.12-2.22-1.68-3.9-1.68-1.12 0-2.3.26-3.54.78-1.24.52-2.46 1.26-3.66 2.22l-.3-.18-.72-2.58c1.88-1.08 3.76-2.04 5.64-2.88 1.92-.88 3.3-1.32 4.14-1.32 2.6 0 4.64.68 6.12 2.04 1.48 1.36 2.22 3.26 2.22 5.7 0 .88-.14 2.68-.42 5.4-.44 4.4-.66 7.2-.66 8.4 0 .88.22 1.56.66 2.04.44.48 1.04.72 1.8.72.64 0 1.3-.14 1.98-.42.68-.32 1.22-.68 1.62-1.08l.84.96c-.6 1-1.38 1.98-2.34 2.94-.92.92-1.88 1.54-2.88 1.86zm-11.16-4.32c.76 0 1.64-.26 2.64-.78 1.04-.56 1.98-1.26 2.82-2.1l.3-6.12-8.16 2.46c-1.16.36-1.74 1.2-1.74 2.52 0 1.16.38 2.12 1.14 2.88.8.76 1.8 1.14 3 1.14zm30.169 4.32c-1.68 0-3.4-.12-5.16-.36-1.72-.2-2.58-.32-2.58-.36l-.54-.48v-37.08c0-2.16-.74-3.24-2.22-3.24-.32 0-.6.02-.84.06-.24.04-.4.08-.48.12l-.18-.18.24-1.98c1.72-.24 3.5-.56 5.34-.96 1.84-.4 3.02-.66 3.54-.78l.36.78c-.28.4-.54 2.44-.78 6.12-.24 3.64-.44 8.3-.6 13.98 1.8-1.28 3.34-2.3 4.62-3.06 1.32-.76 2.2-1.14 2.64-1.14 2.24 0 4.24.54 6 1.62 1.76 1.08 3.12 2.6 4.08 4.56 1 1.92 1.5 4.14 1.5 6.66 0 2.88-.68 5.52-2.04 7.92-1.32 2.4-3.12 4.3-5.4 5.7-2.28 1.4-4.78 2.1-7.5 2.1zm1.68-3.3c2.68 0 4.78-.9 6.3-2.7 1.56-1.84 2.34-4.34 2.34-7.5 0-2-.36-3.84-1.08-5.52-.68-1.68-1.64-3-2.88-3.96-1.2-1-2.52-1.5-3.96-1.5-.8 0-1.82.32-3.06.96-1.24.6-2.36 1.36-3.36 2.28l-.18 16.68c.72.36 1.64.66 2.76.9 1.12.24 2.16.36 3.12.36zm18.289.84c1.2-.32 2.06-.78 2.58-1.38.52-.64.78-1.48.78-2.52v-15.24c0-2.16-.74-3.24-2.22-3.24-.28 0-.58.04-.9.12-.32.04-.52.08-.6.12l.24-2.22c1.68-.24 3.4-.56 5.16-.96 1.8-.4 2.96-.66 3.48-.78l.3.72c-.36.84-.68 3.42-.96 7.74-.28 4.28-.42 8.78-.42 13.5 0 1.16.16 2.02.48 2.58.32.52.86.78 1.62.78.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.48 2.58c-.36-.04-1.04-.08-2.04-.12-1-.04-2.1-.06-3.3-.06-1.04 0-2.24.1-3.6.3-1.32.2-2.18.34-2.58.42l.24-2.46zm5.04-33.18c-.92 0-1.64-.3-2.16-.9-.52-.6-.78-1.32-.78-2.16 0-.96.34-1.78 1.02-2.46.68-.72 1.52-1.08 2.52-1.08.92 0 1.64.3 2.16.9.52.6.78 1.32.78 2.16 0 .96-.34 1.8-1.02 2.52-.68.68-1.52 1.02-2.52 1.02zm28.633 33.18c1.2-.32 2.06-.78 2.58-1.38.52-.64.78-1.48.78-2.52l.24-11.88c0-2-.44-3.54-1.32-4.62-.84-1.08-2.06-1.62-3.66-1.62-1.28 0-2.58.34-3.9 1.02-1.32.64-2.48 1.34-3.48 2.1-.36 8.28-.54 13.2-.54 14.76 0 1.24.16 2.12.48 2.64.32.48.88.72 1.68.72.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.54 2.58c-.36-.04-1.06-.08-2.1-.12-1.04-.04-2.16-.06-3.36-.06-1.04 0-2.2.04-3.48.12l-2.46.24.3-2.46c1.16-.2 1.98-.56 2.46-1.08s.72-1.34.72-2.46v-14.64c0-1.36-.22-2.3-.66-2.82-.44-.56-1.2-.84-2.28-.84h-.66l-.18-.24.18-1.98c1.72-.28 3.42-.6 5.1-.96 1.72-.4 2.82-.66 3.3-.78l.36.48c-.08.24-.2.76-.36 1.56-.16.76-.26 1.56-.3 2.4l.12.18c4.56-3.04 7.5-4.56 8.82-4.56 2.52 0 4.52.7 6 2.1 1.48 1.4 2.22 3.28 2.22 5.64 0 .4-.12 2.24-.36 5.52-.32 4.16-.48 7.06-.48 8.7 0 1.16.16 2.02.48 2.58.32.52.86.78 1.62.78.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.48 2.58c-.36-.04-1.04-.08-2.04-.12-1-.04-2.1-.06-3.3-.06-1.04 0-2.24.1-3.6.3-1.32.2-2.18.34-2.58.42l.24-2.46zm28.011 2.46c-2.48 0-4.68-.54-6.6-1.62-1.92-1.12-3.4-2.68-4.44-4.68-1.04-2.04-1.56-4.36-1.56-6.96 0-2.68.6-5.2 1.8-7.56 1.24-2.36 2.88-4.24 4.92-5.64 2.04-1.4 4.22-2.1 6.54-2.1 2.92 0 5.14.74 6.66 2.22 1.52 1.48 2.28 3.64 2.28 6.48 0 1.16-.12 2.14-.36 2.94l-.78.72h-16.56c-.04 3.88.72 6.88 2.28 9 1.6 2.08 3.82 3.12 6.66 3.12 2.24 0 4.68-.62 7.32-1.86l.36.12.66 1.74a30.927 30.927 0 01-4.8 2.82c-1.72.84-3.18 1.26-4.38 1.26zm3-18.96c.6-.08 1-.22 1.2-.42.2-.2.3-.6.3-1.2 0-1.6-.44-2.82-1.32-3.66-.84-.84-2.06-1.26-3.66-1.26-1.88 0-3.5.64-4.86 1.92-1.32 1.28-2.16 3-2.52 5.16l10.86-.54zm21.495 18.96c-2.72 0-4.64-.54-5.76-1.62-1.12-1.12-1.68-3-1.68-5.64V136.7c0-1.08-.24-1.84-.72-2.28-.48-.44-1.38-.68-2.7-.72l-.24-.36.3-1.8c1.16-.56 2.28-1.24 3.36-2.04 1.12-.84 2.02-1.56 2.7-2.16.72-.64 1.18-1.06 1.38-1.26l1.2.48c-.04.2-.1.68-.18 1.44-.08.76-.18 1.78-.3 3.06l8.82-.18.18.18-.54 3.18-8.7-.18c-.28 4.4-.42 9.4-.42 15 0 2.04.34 3.48 1.02 4.32.72.84 1.94 1.26 3.66 1.26.6 0 1.2-.08 1.8-.24.6-.16 1.1-.32 1.5-.48.4-.2.66-.32.78-.36l.6 1.56c-.24.2-.76.58-1.56 1.14-.76.56-1.6 1.12-2.52 1.68-.88.52-1.54.78-1.98.78zm32.479 0c-1.68 0-3.22-.16-4.62-.48-1.4-.28-2.56-.6-3.48-.96-.88-.36-1.32-.56-1.32-.6l-.3-.6c.04-.24.12-.84.24-1.8.12-.96.22-2.2.3-3.72.12-1.56.18-3.2.18-4.92l2.7-.3c0 3 .2 5.22.6 6.66.4 1.44 1.14 2.44 2.22 3 1.08.52 2.74.78 4.98.78 2.52 0 4.54-.58 6.06-1.74 1.52-1.2 2.28-2.82 2.28-4.86 0-1.2-.42-2.28-1.26-3.24-.8-.96-1.76-1.78-2.88-2.46-1.12-.68-2.78-1.6-4.98-2.76-2.08-1.08-3.78-2.06-5.1-2.94-1.32-.92-2.44-2-3.36-3.24-.88-1.24-1.32-2.68-1.32-4.32 0-2.08.6-3.96 1.8-5.64 1.24-1.72 2.9-3.06 4.98-4.02 2.12-1 4.46-1.5 7.02-1.5 1.6 0 3.08.12 4.44.36 1.36.2 2.44.42 3.24.66.8.24 1.3.4 1.5.48l.18.36c-.04.24-.14.8-.3 1.68-.16.88-.34 2.1-.54 3.66s-.36 3.16-.48 4.8l-2.34.24-.36-.3c.04-.16.08-.52.12-1.08.04-.6.06-1.28.06-2.04 0-2.12-.52-3.58-1.56-4.38-1.04-.8-2.9-1.2-5.58-1.2-2.2 0-4.02.56-5.46 1.68-1.4 1.08-2.1 2.44-2.1 4.08 0 1.6.68 3 2.04 4.2 1.4 1.16 3.44 2.44 6.12 3.84 2.6 1.32 4.58 2.42 5.94 3.3a14.3 14.3 0 013.6 3.18c1.04 1.28 1.56 2.76 1.56 4.44 0 2.24-.64 4.26-1.92 6.06-1.24 1.76-2.98 3.14-5.22 4.14-2.24 1-4.8 1.5-7.68 1.5zm31.036 0c-2.72 0-4.64-.54-5.76-1.62-1.12-1.12-1.68-3-1.68-5.64V136.7c0-1.08-.24-1.84-.72-2.28-.48-.44-1.38-.68-2.7-.72l-.24-.36.3-1.8c1.16-.56 2.28-1.24 3.36-2.04 1.12-.84 2.02-1.56 2.7-2.16.72-.64 1.18-1.06 1.38-1.26l1.2.48c-.04.2-.1.68-.18 1.44-.08.76-.18 1.78-.3 3.06l8.82-.18.18.18-.54 3.18-8.7-.18c-.28 4.4-.42 9.4-.42 15 0 2.04.34 3.48 1.02 4.32.72.84 1.94 1.26 3.66 1.26.6 0 1.2-.08 1.8-.24.6-.16 1.1-.32 1.5-.48.4-.2.66-.32.78-.36l.6 1.56c-.24.2-.76.58-1.56 1.14-.76.56-1.6 1.12-2.52 1.68-.88.52-1.54.78-1.98.78zm21.245 0c-2.28 0-4.3-.56-6.06-1.68-1.76-1.12-3.14-2.68-4.14-4.68-.96-2.04-1.44-4.36-1.44-6.96 0-2.8.6-5.36 1.8-7.68 1.24-2.36 2.92-4.2 5.04-5.52 2.12-1.36 4.48-2.04 7.08-2.04 2.24 0 4.24.56 6 1.68 1.8 1.12 3.18 2.7 4.14 4.74 1 2 1.5 4.3 1.5 6.9 0 2.8-.62 5.38-1.86 7.74-1.2 2.32-2.86 4.16-4.98 5.52-2.12 1.32-4.48 1.98-7.08 1.98zm1.68-2.94c2.24 0 4.02-.9 5.34-2.7 1.32-1.84 1.98-4.32 1.98-7.44 0-2.36-.36-4.46-1.08-6.3-.72-1.88-1.74-3.34-3.06-4.38-1.28-1.04-2.74-1.56-4.38-1.56-2.24 0-4.02.92-5.34 2.76-1.32 1.84-1.98 4.34-1.98 7.5 0 2.36.36 4.46 1.08 6.3.72 1.84 1.72 3.28 3 4.32 1.28 1 2.76 1.5 4.44 1.5zm33.903.48c1.2-.32 2.06-.78 2.58-1.38.52-.64.78-1.48.78-2.52l.24-11.88c0-2-.44-3.54-1.32-4.62-.84-1.08-2.06-1.62-3.66-1.62-1.28 0-2.58.34-3.9 1.02-1.32.64-2.48 1.34-3.48 2.1-.36 8.28-.54 13.2-.54 14.76 0 1.24.16 2.12.48 2.64.32.48.88.72 1.68.72.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.54 2.58c-.36-.04-1.06-.08-2.1-.12a103.05 103.05 0 00-7.02 0c-1.12.04-1.88.06-2.28.06l.36-2.46c1.16-.12 1.96-.42 2.4-.9.48-.48.72-1.28.72-2.4v-14.64c0-1.36-.22-2.3-.66-2.82-.44-.56-1.2-.84-2.28-.84h-.66l-.18-.24.18-1.98c1.72-.28 3.42-.6 5.1-.96 1.72-.4 2.82-.66 3.3-.78l.36.48c-.08.24-.2.76-.36 1.56-.16.76-.26 1.56-.3 2.4l.12.18c4.48-3.04 7.42-4.56 8.82-4.56 1.92 0 3.54.42 4.86 1.26 1.32.8 2.26 1.96 2.82 3.48 1.44-1.04 3.06-2.08 4.86-3.12 1.8-1.08 3.2-1.62 4.2-1.62 2.52 0 4.52.7 6 2.1 1.48 1.4 2.22 3.28 2.22 5.64 0 .4-.12 2.24-.36 5.52-.32 4.16-.48 7.06-.48 8.7 0 1.24.16 2.12.48 2.64.32.48.88.72 1.68.72.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.54 2.58c-.36-.04-1.06-.08-2.1-.12-1.04-.04-2.16-.06-3.36-.06-1.04 0-2.2.04-3.48.12l-2.46.24.3-2.46c1.16-.2 1.98-.56 2.46-1.08s.72-1.34.72-2.46l.24-11.88c0-2-.44-3.54-1.32-4.62-.84-1.08-2.06-1.62-3.66-1.62-2.08 0-4.5 1-7.26 3l-.66 14.88c0 1.16.16 2.02.48 2.58.32.52.86.78 1.62.78.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.48 2.58c-.36-.04-1.04-.08-2.04-.12-1-.04-2.1-.06-3.3-.06-1.04 0-2.24.1-3.6.3-1.32.2-2.18.34-2.58.42l.24-2.46zm52.742 2.46c-3.24 0-5.02-1.62-5.34-4.86l-.24-.06c-1.44 1.44-2.76 2.58-3.96 3.42-1.16.84-2.04 1.26-2.64 1.26-2.24 0-4.08-.7-5.52-2.1-1.44-1.4-2.16-3.18-2.16-5.34 0-1.16.28-2.18.84-3.06.6-.88 1.38-1.46 2.34-1.74l11.4-3.12.06-2.64c0-2-.46-3.56-1.38-4.68-.92-1.12-2.22-1.68-3.9-1.68-1.12 0-2.3.26-3.54.78-1.24.52-2.46 1.26-3.66 2.22l-.3-.18-.72-2.58c1.88-1.08 3.76-2.04 5.64-2.88 1.92-.88 3.3-1.32 4.14-1.32 2.6 0 4.64.68 6.12 2.04 1.48 1.36 2.22 3.26 2.22 5.7 0 .88-.14 2.68-.42 5.4-.44 4.4-.66 7.2-.66 8.4 0 .88.22 1.56.66 2.04.44.48 1.04.72 1.8.72.64 0 1.3-.14 1.98-.42.68-.32 1.22-.68 1.62-1.08l.84.96c-.6 1-1.38 1.98-2.34 2.94-.92.92-1.88 1.54-2.88 1.86zm-11.16-4.32c.76 0 1.64-.26 2.64-.78 1.04-.56 1.98-1.26 2.82-2.1l.3-6.12-8.16 2.46c-1.16.36-1.74 1.2-1.74 2.52 0 1.16.38 2.12 1.14 2.88.8.76 1.8 1.14 3 1.14zm29.149 4.32c-2.72 0-4.64-.54-5.76-1.62-1.12-1.12-1.68-3-1.68-5.64V136.7c0-1.08-.24-1.84-.72-2.28-.48-.44-1.38-.68-2.7-.72l-.24-.36.3-1.8c1.16-.56 2.28-1.24 3.36-2.04 1.12-.84 2.02-1.56 2.7-2.16.72-.64 1.18-1.06 1.38-1.26l1.2.48c-.04.2-.1.68-.18 1.44-.08.76-.18 1.78-.3 3.06l8.82-.18.18.18-.54 3.18-8.7-.18c-.28 4.4-.42 9.4-.42 15 0 2.04.34 3.48 1.02 4.32.72.84 1.94 1.26 3.66 1.26.6 0 1.2-.08 1.8-.24.6-.16 1.1-.32 1.5-.48.4-.2.66-.32.78-.36l.6 1.56c-.24.2-.76.58-1.56 1.14-.76.56-1.6 1.12-2.52 1.68-.88.52-1.54.78-1.98.78zm21.245 0c-2.28 0-4.3-.56-6.06-1.68-1.76-1.12-3.14-2.68-4.14-4.68-.96-2.04-1.44-4.36-1.44-6.96 0-2.8.6-5.36 1.8-7.68 1.24-2.36 2.92-4.2 5.04-5.52 2.12-1.36 4.48-2.04 7.08-2.04 2.24 0 4.24.56 6 1.68 1.8 1.12 3.18 2.7 4.14 4.74 1 2 1.5 4.3 1.5 6.9 0 2.8-.62 5.38-1.86 7.74-1.2 2.32-2.86 4.16-4.98 5.52-2.12 1.32-4.48 1.98-7.08 1.98zm1.68-2.94c2.24 0 4.02-.9 5.34-2.7 1.32-1.84 1.98-4.32 1.98-7.44 0-2.36-.36-4.46-1.08-6.3-.72-1.88-1.74-3.34-3.06-4.38-1.28-1.04-2.74-1.56-4.38-1.56-2.24 0-4.02.92-5.34 2.76-1.32 1.84-1.98 4.34-1.98 7.5 0 2.36.36 4.46 1.08 6.3.72 1.84 1.72 3.28 3 4.32 1.28 1 2.76 1.5 4.44 1.5zm16.263.48c1.12-.32 1.9-.72 2.34-1.2.48-.48.76-1.06.84-1.74.12-.68.18-1.82.18-3.42v-29.46c0-1.24-.14-2.08-.42-2.52-.28-.44-.86-.66-1.74-.66-.2 0-.66.04-1.38.12l-.18-.12.24-2.04c3.36-.48 6.32-1.06 8.88-1.74l.36.78c-.44.68-.84 4.96-1.2 12.84-.32 7.88-.48 16.22-.48 25.02 0 1.2.16 2.06.48 2.58.32.52.86.78 1.62.78l2.1-.12.12.24-.48 2.58c-2.64-.12-4.42-.18-5.34-.18-1.36 0-3.42.24-6.18.72l.24-2.46zm26.588 2.46c-2.28 0-4.3-.56-6.06-1.68-1.76-1.12-3.14-2.68-4.14-4.68-.96-2.04-1.44-4.36-1.44-6.96 0-2.8.6-5.36 1.8-7.68 1.24-2.36 2.92-4.2 5.04-5.52 2.12-1.36 4.48-2.04 7.08-2.04 2.24 0 4.24.56 6 1.68 1.8 1.12 3.18 2.7 4.14 4.74 1 2 1.5 4.3 1.5 6.9 0 2.8-.62 5.38-1.86 7.74-1.2 2.32-2.86 4.16-4.98 5.52-2.12 1.32-4.48 1.98-7.08 1.98zm1.68-2.94c2.24 0 4.02-.9 5.34-2.7 1.32-1.84 1.98-4.32 1.98-7.44 0-2.36-.36-4.46-1.08-6.3-.72-1.88-1.74-3.34-3.06-4.38-1.28-1.04-2.74-1.56-4.38-1.56-2.24 0-4.02.92-5.34 2.76-1.32 1.84-1.98 4.34-1.98 7.5 0 2.36.36 4.46 1.08 6.3.72 1.84 1.72 3.28 3 4.32 1.28 1 2.76 1.5 4.44 1.5zm42.903-23.16c-.76.12-2.48.3-5.16.54l-.24.3c1.6 1.76 2.4 3.8 2.4 6.12 0 1.92-.54 3.7-1.62 5.34-1.04 1.64-2.46 2.94-4.26 3.9-1.8.92-3.78 1.38-5.94 1.38-1.16 0-2.28-.16-3.36-.48-.92.52-1.58 1-1.98 1.44-.4.44-.6.88-.6 1.32 0 .92.62 1.56 1.86 1.92 1.24.36 3.18.7 5.82 1.02 2.6.32 4.7.66 6.3 1.02 1.6.32 2.98.92 4.14 1.8 1.16.88 1.74 2.1 1.74 3.66 0 1.76-.72 3.46-2.16 5.1-1.4 1.64-3.26 2.96-5.58 3.96-2.28 1.04-4.64 1.56-7.08 1.56-2.84 0-5.08-.72-6.72-2.16-1.6-1.4-2.4-3.34-2.4-5.82.56-.72 1.36-1.56 2.4-2.52 1.08-.96 2.26-1.92 3.54-2.88v-.36c-2.08-.36-3.68-1.04-4.8-2.04-1.12-1-1.7-2.28-1.74-3.84a28.95 28.95 0 015.04-3.84v-.24c-1.4-.8-2.5-1.86-3.3-3.18-.76-1.36-1.14-2.88-1.14-4.56 0-1.96.5-3.76 1.5-5.4 1.04-1.68 2.4-3.02 4.08-4.02 1.72-1 3.58-1.5 5.58-1.5.92 0 2.06.12 3.42.36 1 .2 1.82.3 2.46.3 1.8-.2 4.56-.8 8.28-1.8l.18.24-.66 3.36zm-13.44 14.94c1.84 0 3.28-.58 4.32-1.74 1.08-1.16 1.62-2.76 1.62-4.8 0-2.32-.64-4.2-1.92-5.64-1.28-1.44-2.94-2.16-4.98-2.16-1.84 0-3.3.6-4.38 1.8-1.04 1.2-1.56 2.82-1.56 4.86 0 2.28.64 4.14 1.92 5.58 1.28 1.4 2.94 2.1 4.98 2.1zm-2.88 11.7c-1.2.84-2.12 1.76-2.76 2.76-.64 1.04-.96 2.06-.96 3.06 0 1.36.58 2.44 1.74 3.24 1.16.84 2.7 1.26 4.62 1.26 1.52 0 2.96-.28 4.32-.84 1.4-.52 2.52-1.24 3.36-2.16.84-.92 1.26-1.9 1.26-2.94 0-.8-.3-1.44-.9-1.92-.6-.48-1.72-.9-3.36-1.26-1.6-.36-4.04-.76-7.32-1.2zm20.758-3c1.2-.32 2.06-.78 2.58-1.38.52-.64.78-1.48.78-2.52v-15.24c0-2.16-.74-3.24-2.22-3.24-.28 0-.58.04-.9.12-.32.04-.52.08-.6.12l.24-2.22c1.68-.24 3.4-.56 5.16-.96 1.8-.4 2.96-.66 3.48-.78l.3.72c-.36.84-.68 3.42-.96 7.74-.28 4.28-.42 8.78-.42 13.5 0 1.16.16 2.02.48 2.58.32.52.86.78 1.62.78.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.48 2.58c-.36-.04-1.04-.08-2.04-.12-1-.04-2.1-.06-3.3-.06-1.04 0-2.24.1-3.6.3-1.32.2-2.18.34-2.58.42l.24-2.46zm5.04-33.18c-.92 0-1.64-.3-2.16-.9-.52-.6-.78-1.32-.78-2.16 0-.96.34-1.78 1.02-2.46.68-.72 1.52-1.08 2.52-1.08.92 0 1.64.3 2.16.9.52.6.78 1.32.78 2.16 0 .96-.34 1.8-1.02 2.52-.68.68-1.52 1.02-2.52 1.02zm23.714 35.64c-3.8 0-6.84-1.2-9.12-3.6-2.28-2.4-3.42-5.62-3.42-9.66 0-2.84.6-5.42 1.8-7.74 1.24-2.36 2.9-4.2 4.98-5.52 2.12-1.36 4.48-2.04 7.08-2.04 1.12 0 2.2.08 3.24.24 1.04.16 1.88.34 2.52.54.68.16 1.1.28 1.26.36l.18.42c-.04.2-.16.68-.36 1.44-.16.72-.34 1.7-.54 2.94-.2 1.2-.32 2.5-.36 3.9l-2.46.18v-1.86c0-1.48-.46-2.66-1.38-3.54-.88-.92-2.06-1.38-3.54-1.38-2.44 0-4.32.88-5.64 2.64-1.32 1.72-1.98 4.18-1.98 7.38 0 3.48.72 6.24 2.16 8.28 1.48 2 3.48 3 6 3 1 0 2-.14 3-.42 1-.32 1.84-.62 2.52-.9.68-.32 1.1-.54 1.26-.66l.36.12.66 1.86c-.28.2-.9.62-1.86 1.26-.92.64-2 1.26-3.24 1.86-1.2.6-2.24.9-3.12.9zm29.21-25.56l-7.5.36c-1.96.12-3.32.56-4.08 1.32-.72.72-1.18 2.08-1.38 4.08l-2.34.36c.08-.56.2-1.74.36-3.54.16-1.84.26-3.56.3-5.16l.36-.3 7.68.48 12.6.3.48 1.26c-3.68 4.72-7.06 9.24-10.14 13.56-3.08 4.28-5.42 7.62-7.02 10.02l8.88-.54c1.6-.12 2.84-.74 3.72-1.86.88-1.16 1.52-2.98 1.92-5.46l2.4-.3c-.04.28-.14.92-.3 1.92-.16 1-.32 2.22-.48 3.66-.16 1.44-.24 2.8-.24 4.08l-.96.96-16.86-.54-3.12.3-.6-1.5 16.32-23.46zm28.737 23.1c1.2-.32 2.06-.78 2.58-1.38.52-.64.78-1.48.78-2.52l.24-11.88c0-2-.44-3.54-1.32-4.62-.84-1.08-2.06-1.62-3.66-1.62-1.28 0-2.58.34-3.9 1.02-1.32.64-2.48 1.34-3.48 2.1-.36 8.28-.54 13.2-.54 14.76 0 1.24.16 2.12.48 2.64.32.48.88.72 1.68.72.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.54 2.58c-.36-.04-1.06-.08-2.1-.12-1.04-.04-2.16-.06-3.36-.06-1.04 0-2.2.04-3.48.12l-2.46.24.3-2.46c1.16-.2 1.98-.56 2.46-1.08s.72-1.34.72-2.46v-14.64c0-1.36-.22-2.3-.66-2.82-.44-.56-1.2-.84-2.28-.84h-.66l-.18-.24.18-1.98c1.72-.28 3.42-.6 5.1-.96 1.72-.4 2.82-.66 3.3-.78l.36.48c-.08.24-.2.76-.36 1.56-.16.76-.26 1.56-.3 2.4l.12.18c4.56-3.04 7.5-4.56 8.82-4.56 2.52 0 4.52.7 6 2.1 1.48 1.4 2.22 3.28 2.22 5.64 0 .4-.12 2.24-.36 5.52-.32 4.16-.48 7.06-.48 8.7 0 1.16.16 2.02.48 2.58.32.52.86.78 1.62.78.44 0 .86-.02 1.26-.06.4-.04.68-.06.84-.06l.12.24-.48 2.58c-.36-.04-1.04-.08-2.04-.12-1-.04-2.1-.06-3.3-.06-1.04 0-2.24.1-3.6.3-1.32.2-2.18.34-2.58.42l.24-2.46zm14.298 16.2c-.32 0-.84-.48-1.56-1.44-.72-.92-1.08-1.58-1.08-1.98l.3-.42c2.24 0 4.32-.94 6.24-2.82 1.96-1.84 3.64-4.44 5.04-7.8-3.08-9.76-5.56-17.12-7.44-22.08-.36-1-.88-1.72-1.56-2.16-.64-.44-1.48-.68-2.52-.72l-.12-.24.36-1.98 4.98.06c1.48 0 2.94-.06 4.38-.18 1.48-.12 2.42-.2 2.82-.24l.12.3-.36 1.86c-1.36.04-2.28.18-2.76.42-.44.2-.66.58-.66 1.14 0 .64.38 2.3 1.14 4.98.8 2.68 1.62 5.36 2.46 8.04.84 2.64 1.4 4.36 1.68 5.16h.24c4.6-11 6.9-16.98 6.9-17.94 0-1.04-.76-1.56-2.28-1.56h-2.76l-.12-.24.36-1.98c.36.04 1.16.1 2.4.18 1.24.04 2.48.06 3.72.06l5.1-.06-.42 2.22c-.88.16-1.56.48-2.04.96-.44.44-.88 1.26-1.32 2.46l-7.62 18.24c-2.08 5.04-3.78 8.78-5.1 11.22-1.32 2.44-2.62 4.14-3.9 5.1-1.28 1-2.82 1.48-4.62 1.44z",
    fill: "#292B37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.384 62.145h26.16c7.824-41.547-4.528-56.959-13.08-62.145-8.552 5.186-20.904 20.599-13.08 62.145z",
    fill: "url(#logo-full_svg__paint0_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.788 70.75l25.16-7.102C99.985 21.568 83.843 10.097 74.185 7.43c-6.791 7.309-14.41 25.485 4.603 63.319z",
    fill: "url(#logo-full_svg__paint1_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.148 43.642c-.861 9.897 4.328 28.895 42.722 47.31L79.394 70.09c-21.22-22.525-37.522-28.252-48.396-28.252-4.041 0-7.334.79-9.85 1.804z",
    fill: "url(#logo-full_svg__paint2_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.117 66.95c1.649 9.799 11.445 26.92 53.254 35.297l9.8-24.034c-19.854-12.565-34.553-16.49-45.093-16.49-8.544 0-14.355 2.58-17.961 5.226z",
    fill: "url(#logo-full_svg__paint3_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 93.517c4.468 8.893 18.889 22.429 61.343 18.327l2.28-25.821c-12.728-3.514-23.101-4.898-31.538-4.898-18.799 0-27.972 6.877-32.085 12.392z",
    fill: "url(#logo-full_svg__paint4_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.226 157.057c8.997 4.383 28.749 6.475 59.986-22.306l-13.999-21.897c-39.61 15.683-46.141 34.27-45.987 44.203z",
    fill: "url(#logo-full_svg__paint5_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.523 178.28c9.93 1.367 29.348-2.778 49.908-39.809l-20.22-16.447c-32.654 27.192-32.977 46.871-29.688 56.256z",
    fill: "url(#logo-full_svg__paint6_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.755 200c9.721-2.432 26.14-13.507 31.14-55.481l-24.977-7.708c-19.94 37.362-12.771 55.717-6.163 63.189z",
    fill: "url(#logo-full_svg__paint7_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.14 136.976c-6.283 41.804 6.632 56.758 15.369 61.629 8.355-5.492 20.129-21.344 10.774-62.578l-26.143.949z",
    fill: "url(#logo-full_svg__paint8_radial)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.414 136.686c6.056 41.835 22.751 52.502 32.531 54.691 6.418-7.632 13.12-26.159-7.756-63.015l-24.775 8.324z",
    fill: "url(#logo-full_svg__paint9_radial)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.603 128.087c7.329 6.781 25.62 14.458 63.937-4.112l-6.988-24.978c-42.498 3.628-54.19 19.54-56.949 29.09z",
    fill: "url(#logo-full_svg__paint10_radial)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.38 136.323c27.836 32.025 47.699 32.111 57.13 28.739 1.262-9.854-3.155-29.043-40.772-48.968l-16.358 20.229z",
    fill: "url(#logo-full_svg__paint11_radial)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.464 20.595c-4.443 8.905-6.596 28.47 22.386 59.481l22.13-13.824c-15.592-38.897-34.127-45.66-44.222-45.66-.098 0-.197 0-.294.003z",
    fill: "url(#logo-full_svg__paint12_radial)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.759 128.386c34.319 25.1 53.705 20.81 62.145 15.448-.978-9.887-9.589-27.624-50.733-38.772l-11.412 23.324z",
    fill: "url(#logo-full_svg__paint13_radial)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.856 93.619l-3.143 25.732c40.689 12.688 57.616 2.389 63.839-5.4-3.811-8.261-15.806-20.673-50.369-20.673-3.24 0-6.679.11-10.327.34z",
    fill: "url(#logo-full_svg__paint14_radial)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.931 82.326l5.17 25.407c42.651-.612 55.459-15.656 58.899-24.987-4.037-4.31-11.878-9.204-25.81-9.203-9.608 0-22.113 2.329-38.259 8.783z",
    fill: "url(#logo-full_svg__paint15_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.491 144.298c17.879 38.372 36.954 43.862 46.958 43.189 3.946-9.131 5.022-28.784-25.622-58.185-9.915 6.97-11.421 8.028-21.336 14.996z",
    fill: "url(#logo-full_svg__paint16_radial)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.937 74.834l12.882 22.56c40.349-13.711 47.805-31.954 48.149-41.882-3.104-1.707-7.568-3.194-13.493-3.194-10.803.001-26.456 4.947-47.538 22.516z",
    fill: "url(#logo-full_svg__paint17_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.085 67.612l18.466 18.36c35.224-23.836 37.524-43.384 35.195-53.046a24.646 24.646 0 00-5.774-.662c-10.772 0-27.798 6.418-47.887 35.348z",
    fill: "url(#logo-full_svg__paint18_radial)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.972 65.153l25.269 6.708c18.411-38.124 10.505-56.18 3.6-63.381-9.616 2.816-25.574 14.536-28.87 56.673z",
    fill: "url(#logo-full_svg__paint19_radial)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 66.529l22.587 13.077c27.911-31.96 25.094-51.442 20.351-60.195-10.025.203-28.538 7.336-42.938 47.118z",
    fill: "url(#logo-full_svg__paint20_radial)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.41 120.445c24.402 34.665 44.155 36.751 53.882 34.349 2.268-9.678-.157-29.212-35.534-52.824l-18.348 18.475z",
    fill: "url(#logo-full_svg__paint21_radial)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.907 118.807c39.727 15.391 57.321 6.252 64.062-1.101-3.54-9.293-16.511-24.201-59.165-24.36l-4.897 25.461z",
    fill: "url(#logo-full_svg__paint22_radial)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 88.737l6.095 25.206c42.602-2.141 54.85-17.635 57.948-27.083-3.98-3.952-11.412-8.31-24.076-8.31-9.866.001-22.908 2.645-39.967 10.187z",
    fill: "url(#logo-full_svg__paint23_radial)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.566 83.76L119.7 95.863c26.501-33.116 22.844-52.461 17.726-61.003-10.007.628-28.194 8.54-40.86 48.898z",
    fill: "url(#logo-full_svg__paint24_radial)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.444 79.468l26.139-1.044c6.13-41.825-6.839-56.733-15.594-61.573-8.335 5.523-20.05 21.415-10.545 62.617z",
    fill: "url(#logo-full_svg__paint25_radial)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.593 102.714l24.396-9.356c-7.841-41.544-24.976-51.499-34.841-53.276-6.085 7.895-11.989 26.687 10.445 62.632z",
    fill: "url(#logo-full_svg__paint26_radial)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.597 64.272c.009 9.933 6.846 28.413 46.71 43.452l13.635-22.12c-21.217-18.92-37.062-24.098-47.9-24.097-5.357 0-9.493 1.267-12.445 2.765z",
    fill: "url(#logo-full_svg__paint27_radial)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.678 99.082c4.829 8.706 19.79 21.653 62.041 15.854.569-12.031.657-13.859 1.225-25.891-11.252-2.626-20.637-3.695-28.455-3.695-21.029 0-30.707 7.738-34.81 13.732z",
    fill: "url(#logo-full_svg__paint28_radial)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.002 144.594c9.27 3.787 29.117 4.587 58.375-26.168L85.954 97.489c-38.483 18.231-43.766 37.204-42.952 47.105z",
    fill: "url(#logo-full_svg__paint29_radial)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.054 171.096c9.963-1.114 27.736-9.903 38.385-50.828-11.017-5.096-12.69-5.869-23.705-10.966-24.828 34.367-20.215 53.512-14.68 61.794z",
    fill: "url(#logo-full_svg__paint30_radial)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.17 114.579c2.98 42.16 18.849 53.997 28.442 56.884 6.96-7.152 15-25.149-3.125-63.407l-25.318 6.523z",
    fill: "url(#logo-full_svg__paint31_radial)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104.709 65.172c5.713 0 11.426-1.427 17.139-3.274 4.683-1.513 9.628-2.23 14.823-1.714 11.572 1.149 19.184 8.557 18.767 19.374-.205 5.351-1.385 10.613-3.623 15.52l-4.132 9.057c-3.381 7.41-3.841 10.911-5.312 18.779-1.472 7.875-.845 17.114-2.255 26.272-.836 5.425-4.65 12.19-9.517 12.19-5.414 0-9.158-5.542-10.913-11.622-3.859-13.367-8.217-24.431-14.977-24.431s-11.119 11.064-14.977 24.431c-1.755 6.08-5.498 11.622-10.913 11.622-4.867 0-8.68-6.765-9.516-12.19-1.41-9.158-.784-18.397-2.256-26.272-1.47-7.868-1.93-11.369-5.312-18.779l-4.131-9.056c-2.24-4.908-3.418-10.17-3.624-15.521-.417-10.817 7.195-18.226 18.767-19.374 5.194-.516 10.14.2 14.823 1.714 5.713 1.847 11.426 3.274 17.139 3.274z",
    fill: "#234937"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M101.464 61.956c5.712 0 11.425-1.427 17.139-3.274 4.682-1.513 9.628-2.23 14.823-1.714 11.571 1.149 19.184 8.558 18.767 19.374-.206 5.352-1.385 10.613-3.624 15.521l-4.131 9.055c-3.381 7.411-3.841 10.912-5.312 18.781-1.472 7.875-.846 17.113-2.256 26.271-.836 5.425-4.65 12.191-9.517 12.191-5.414 0-9.157-5.542-10.912-11.622-3.859-13.368-8.217-24.432-14.977-24.432s-11.12 11.064-14.977 24.432c-1.755 6.08-5.499 11.622-10.914 11.622-4.867 0-8.68-6.766-9.516-12.191-1.41-9.158-.784-18.396-2.255-26.271-1.471-7.869-1.931-11.37-5.312-18.781l-4.132-9.055c-2.24-4.908-3.417-10.17-3.623-15.52-.417-10.817 7.195-18.226 18.766-19.375 5.195-.515 10.14.201 14.823 1.714 5.713 1.847 11.427 3.274 17.14 3.274z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.384 62.145h26.16c7.824-41.547-4.528-56.959-13.08-62.145-8.552 5.186-20.904 20.599-13.08 62.145z",
    fill: "url(#logo-full_svg__paint32_radial)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.788 70.75l25.16-7.102C99.985 21.568 83.843 10.097 74.185 7.43c-6.791 7.309-14.41 25.485 4.603 63.319z",
    fill: "url(#logo-full_svg__paint33_radial)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.148 43.642c-.861 9.897 4.328 28.895 42.722 47.31L79.394 70.09c-21.22-22.525-37.522-28.252-48.396-28.252-4.041 0-7.334.79-9.85 1.804z",
    fill: "url(#logo-full_svg__paint34_radial)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.117 66.95c1.649 9.799 11.445 26.92 53.254 35.297l9.8-24.034c-19.854-12.565-34.553-16.49-45.093-16.49-8.544 0-14.355 2.58-17.961 5.226z",
    fill: "url(#logo-full_svg__paint35_radial)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 93.517c4.468 8.893 18.889 22.429 61.343 18.327l2.28-25.821c-12.728-3.514-23.101-4.898-31.538-4.898-18.799 0-27.972 6.877-32.085 12.392z",
    fill: "url(#logo-full_svg__paint36_radial)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.226 157.057c8.997 4.383 28.749 6.475 59.986-22.306l-13.999-21.897c-39.61 15.683-46.141 34.27-45.987 44.203z",
    fill: "url(#logo-full_svg__paint37_radial)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38.523 178.28c9.93 1.367 29.348-2.778 49.908-39.809l-20.22-16.447c-32.654 27.192-32.977 46.871-29.688 56.256z",
    fill: "url(#logo-full_svg__paint38_radial)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M70.755 200c9.721-2.432 26.14-13.507 31.14-55.481l-24.977-7.708c-19.94 37.362-12.771 55.717-6.163 63.189z",
    fill: "url(#logo-full_svg__paint39_radial)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M89.14 136.976c-6.283 41.804 6.632 56.758 15.369 61.629 8.355-5.492 20.129-21.344 10.774-62.578l-26.143.949z",
    fill: "url(#logo-full_svg__paint40_radial)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M99.414 136.686c6.056 41.835 22.751 52.502 32.531 54.691 6.418-7.632 13.12-26.159-7.756-63.015l-24.775 8.324z",
    fill: "url(#logo-full_svg__paint41_radial)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.603 128.087c7.329 6.781 25.62 14.458 63.937-4.112l-6.988-24.978c-42.498 3.628-54.19 19.54-56.949 29.09z",
    fill: "url(#logo-full_svg__paint42_radial)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M123.38 136.323c27.836 32.025 47.699 32.111 57.13 28.739 1.262-9.854-3.155-29.043-40.772-48.968l-16.358 20.229z",
    fill: "url(#logo-full_svg__paint43_radial)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M49.464 20.595c-4.443 8.905-6.596 28.47 22.386 59.481l22.13-13.824c-15.592-38.897-34.127-45.66-44.222-45.66-.098 0-.197 0-.294.003z",
    fill: "url(#logo-full_svg__paint44_radial)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M125.759 128.386c34.319 25.1 53.705 20.81 62.145 15.448-.978-9.887-9.589-27.624-50.733-38.772l-11.412 23.324z",
    fill: "url(#logo-full_svg__paint45_radial)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M137.856 93.619l-3.143 25.732c40.689 12.688 57.616 2.389 63.839-5.4-3.811-8.261-15.806-20.673-50.369-20.673-3.24 0-6.679.11-10.327.34z",
    fill: "url(#logo-full_svg__paint46_radial)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M135.931 82.326l5.17 25.407c42.651-.612 55.459-15.656 58.899-24.987-4.037-4.31-11.878-9.204-25.81-9.203-9.608 0-22.113 2.329-38.259 8.783z",
    fill: "url(#logo-full_svg__paint47_radial)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M115.491 144.298c17.879 38.372 36.954 43.862 46.958 43.189 3.946-9.131 5.022-28.784-25.622-58.185-9.915 6.97-11.421 8.028-21.336 14.996z",
    fill: "url(#logo-full_svg__paint48_radial)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M123.937 74.834l12.882 22.56c40.349-13.711 47.805-31.954 48.149-41.882-3.104-1.707-7.568-3.194-13.493-3.194-10.803.001-26.456 4.947-47.538 22.516z",
    fill: "url(#logo-full_svg__paint49_radial)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M118.085 67.612l18.466 18.36c35.224-23.836 37.524-43.384 35.195-53.046a24.646 24.646 0 00-5.774-.662c-10.772 0-27.798 6.418-47.887 35.348z",
    fill: "url(#logo-full_svg__paint50_radial)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M97.972 65.153l25.269 6.708c18.411-38.124 10.505-56.18 3.6-63.381-9.616 2.816-25.574 14.536-28.87 56.673z",
    fill: "url(#logo-full_svg__paint51_radial)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 66.529l22.587 13.077c27.911-31.96 25.094-51.442 20.351-60.195-10.025.203-28.538 7.336-42.938 47.118z",
    fill: "url(#logo-full_svg__paint52_radial)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M101.41 120.445c24.402 34.665 44.155 36.751 53.882 34.349 2.268-9.678-.157-29.212-35.534-52.824l-18.348 18.475z",
    fill: "url(#logo-full_svg__paint53_radial)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M118.907 118.807c39.727 15.391 57.321 6.252 64.062-1.101-3.54-9.293-16.511-24.201-59.165-24.36l-4.897 25.461z",
    fill: "url(#logo-full_svg__paint54_radial)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 88.737l6.095 25.206c42.602-2.141 54.85-17.635 57.948-27.083-3.98-3.952-11.412-8.31-24.076-8.31-9.866.001-22.908 2.645-39.967 10.187z",
    fill: "url(#logo-full_svg__paint55_radial)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M96.566 83.76L119.7 95.863c26.501-33.116 22.844-52.461 17.726-61.003-10.007.628-28.194 8.54-40.86 48.898z",
    fill: "url(#logo-full_svg__paint56_radial)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M87.444 79.468l26.139-1.044c6.13-41.825-6.839-56.733-15.594-61.573-8.335 5.523-20.05 21.415-10.545 62.617z",
    fill: "url(#logo-full_svg__paint57_radial)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M87.593 102.714l24.396-9.356c-7.841-41.544-24.976-51.499-34.841-53.276-6.085 7.895-11.989 26.687 10.445 62.632z",
    fill: "url(#logo-full_svg__paint58_radial)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38.597 64.272c.009 9.933 6.846 28.413 46.71 43.452l13.635-22.12c-21.217-18.92-37.062-24.098-47.9-24.097-5.357 0-9.493 1.267-12.445 2.765z",
    fill: "url(#logo-full_svg__paint59_radial)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M31.678 99.082c4.829 8.706 19.79 21.653 62.041 15.854.569-12.031.657-13.859 1.225-25.891-11.252-2.626-20.637-3.695-28.455-3.695-21.029 0-30.707 7.738-34.81 13.732z",
    fill: "url(#logo-full_svg__paint60_radial)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M43.002 144.594c9.27 3.787 29.117 4.587 58.375-26.168L85.954 97.489c-38.483 18.231-43.766 37.204-42.952 47.105z",
    fill: "url(#logo-full_svg__paint61_radial)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69.054 171.096c9.963-1.114 27.736-9.903 38.385-50.828-11.017-5.096-12.69-5.869-23.705-10.966-24.828 34.367-20.215 53.512-14.68 61.794z",
    fill: "url(#logo-full_svg__paint62_radial)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M91.17 114.579c2.98 42.16 18.849 53.997 28.442 56.884 6.96-7.152 15-25.149-3.125-63.407l-25.318 6.523z",
    fill: "url(#logo-full_svg__paint63_radial)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M104.709 65.172c5.713 0 11.426-1.427 17.139-3.274 4.683-1.513 9.628-2.23 14.823-1.714 11.572 1.149 19.184 8.557 18.767 19.374-.205 5.351-1.385 10.613-3.623 15.52l-4.132 9.057c-3.381 7.41-3.841 10.911-5.312 18.779-1.472 7.875-.845 17.114-2.255 26.272-.836 5.425-4.65 12.19-9.517 12.19-5.414 0-9.158-5.542-10.913-11.622-3.859-13.367-8.217-24.431-14.977-24.431s-11.119 11.064-14.977 24.431c-1.755 6.08-5.498 11.622-10.913 11.622-4.867 0-8.68-6.765-9.516-12.19-1.41-9.158-.784-18.397-2.256-26.272-1.47-7.868-1.93-11.369-5.312-18.779l-4.131-9.056c-2.24-4.908-3.418-10.17-3.624-15.521-.417-10.817 7.195-18.226 18.767-19.374 5.194-.516 10.14.2 14.823 1.714 5.713 1.847 11.426 3.274 17.139 3.274z",
    fill: "#234937"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M101.464 61.956c5.712 0 11.425-1.427 17.139-3.274 4.682-1.513 9.628-2.23 14.823-1.714 11.571 1.149 19.184 8.558 18.767 19.374-.206 5.352-1.385 10.613-3.624 15.521l-4.131 9.055c-3.381 7.411-3.841 10.912-5.312 18.781-1.472 7.875-.846 17.113-2.256 26.271-.836 5.425-4.65 12.191-9.517 12.191-5.414 0-9.157-5.542-10.912-11.622-3.859-13.368-8.217-24.432-14.977-24.432s-11.12 11.064-14.977 24.432c-1.755 6.08-5.499 11.622-10.914 11.622-4.867 0-8.68-6.766-9.516-12.191-1.41-9.158-.784-18.396-2.255-26.271-1.471-7.869-1.931-11.37-5.312-18.781l-4.132-9.055c-2.24-4.908-3.417-10.17-3.623-15.52-.417-10.817 7.195-18.226 18.766-19.375 5.195-.515 10.14.201 14.823 1.714 5.713 1.847 11.427 3.274 17.14 3.274z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-89.863 77.17 -26.506) scale(56.5416 57.0662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-109.04 67.567 -3.242) scale(65.9086 66.3905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-141.676 53.922 29.06) scale(76.7044 76.5441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-158.878 47.482 39.16) scale(80.3118 79.7661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-70.72398 -6.4314 6.37327 -70.08461 64.006 98.961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(152.567 28.651 68.507) scale(92.4825 91.9949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(133.408 18.822 79.386) scale(85.207 85.2543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(109.972 4.053 97.279) scale(83.5388 84.1338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(88.036 -11.22 112.366) scale(82.8511 83.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(72.748 -28.92 135.899) scale(76.6019 77.1882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(164.794 30.263 59.584) scale(79.1758 78.5486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(65.58535 58.6852 -58.62772 65.52111 122.83 113.968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-43.54314 -64.9826 65.21355 -43.69789 87.13 79.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(28.372 -159.61 305.09) scale(75.0001 74.6235)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(73.8343 12.86253 -12.75128 73.19571 129.185 101.909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(74.64561 -11.38868 11.28877 73.99079 129.185 92.932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(43.94896 68.33207 -68.59675 44.11919 121.207 120.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-26.354 241.36 -247.604) scale(63.6849 63.3313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-42.426 161.541 -131.394) scale(66.1346 66.0826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.60794 -62.70476 63.18331 19.75759 110.794 62.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(36.6467 -63.77665 64.07596 36.81868 113.634 78.194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint21_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(46.115 -71.8 179.22) scale(75.1036 75.1338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint22_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(9.418 -582.689 705.231) scale(91.7034 90.9058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint23_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-12.812 510.869 -376.394) scale(86.398 85.6823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-61.919 133.244 -36.909) scale(79.5755 79.9881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-92.969 89.77 -7.325) scale(67.8873 68.5138)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint26_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-113.301 84.357 15.203) scale(67.6895 68.1219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint27_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-59.36485 -36.04191 35.8899 -59.11449 95.379 98.157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint28_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-177.217 49.595 49.445) scale(80.0139 79.2819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint29_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-57.20112 40.06159 -39.93681 -57.02297 96.19 106.465)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint30_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(117.445 16.664 83.09) scale(88.0195 88.4907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint31_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(71.329 -20.118 112.402) scale(95.8878 96.5959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint32_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-89.863 77.17 -26.506) scale(56.5416 57.0662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint33_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-109.04 67.567 -3.242) scale(65.9086 66.3905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint34_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-141.676 53.922 29.06) scale(76.7044 76.5441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint35_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-158.878 47.482 39.16) scale(80.3118 79.7661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint36_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-70.72398 -6.4314 6.37327 -70.08461 64.006 98.961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(152.567 28.651 68.507) scale(92.4825 91.9949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint38_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(133.408 18.822 79.386) scale(85.207 85.2543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint39_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(109.972 4.053 97.279) scale(83.5388 84.1338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint40_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(88.036 -11.22 112.366) scale(82.8511 83.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint41_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(72.748 -28.92 135.899) scale(76.6019 77.1882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint42_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(164.794 30.263 59.584) scale(79.1758 78.5486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint43_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(65.58535 58.6852 -58.62772 65.52111 122.83 113.968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint44_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-43.54314 -64.9826 65.21355 -43.69789 87.13 79.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint45_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(28.372 -159.61 305.09) scale(75.0001 74.6235)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint46_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(73.8343 12.86253 -12.75128 73.19571 129.185 101.909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint47_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(74.64561 -11.38868 11.28877 73.99079 129.185 92.932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint48_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(43.94896 68.33207 -68.59675 44.11919 121.207 120.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint49_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-26.354 241.36 -247.604) scale(63.6849 63.3313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint50_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-42.426 161.541 -131.394) scale(66.1346 66.0826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint51_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.60794 -62.70476 63.18331 19.75759 110.794 62.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint52_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(36.6467 -63.77665 64.07596 36.81868 113.634 78.194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BAF7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint53_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(46.115 -71.8 179.22) scale(75.1036 75.1338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint54_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(9.418 -582.689 705.231) scale(91.7034 90.9058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint55_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-12.812 510.869 -376.394) scale(86.398 85.6823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint56_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-61.919 133.244 -36.909) scale(79.5755 79.9881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint57_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-92.969 89.77 -7.325) scale(67.8873 68.5138)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint58_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-113.301 84.357 15.203) scale(67.6895 68.1219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint59_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-59.36485 -36.04191 35.8899 -59.11449 95.379 98.157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint60_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-177.217 49.595 49.445) scale(80.0139 79.2819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D4B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint61_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-57.20112 40.06159 -39.93681 -57.02297 96.19 106.465)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint62_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(117.445 16.664 83.09) scale(88.0195 88.4907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17412B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C386"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-full_svg__paint63_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(71.329 -20.118 112.402) scale(95.8878 96.5959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCB90"
  })))));
}

export default __webpack_public_path__ + "static/logo-full.fb184f88.svg";
export { SvgLogoFull as ReactComponent };